module.exports = __webpack_public_path__ + "img/img_3.f77739a5.png";